import { render, staticRenderFns } from "./InventoryTargetting.vue?vue&type=template&id=6b982dac&"
import script from "./InventoryTargetting.vue?vue&type=script&lang=ts&"
export * from "./InventoryTargetting.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryTargetting.vue?vue&type=style&index=0&id=6b982dac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports